// extracted by mini-css-extract-plugin
module.exports = {"container":"Calculator_container__OPDVW","wrapper":"Calculator_wrapper__3YTeh","columnsWrapper":"Calculator_columnsWrapper__1RYM4","column":"Calculator_column__JX3e0"};